import React, { useEffect } from "react";
import { Button, Form, Row, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import {
  fetchUsers,
  fetchUsersWithProjects,
} from "../../store/slices/userSlice";
import {
  affecterProject,
  fetchProjects,
  setSelectedProjects,
} from "../../store/slices/projectSlice";
import toast from "react-hot-toast";

interface Props  {
  setSelectedRowKeys:any;
}

const Affectation_formulaire: React.FC<Props> = ({setSelectedRowKeys}) => {
  const [form] = Form.useForm();
  const { users } = useSelector((state: RootState) => state.user);
  const { projects, loading } = useSelector(
    (state: RootState) => state.projects
  );
  const isLoading: boolean =
    loading !== "idle" && loading !== "succeeded" && loading !== "failed";

  const initialeState = {
    fk_projet: null,
    fk_utilisateur: null,
  };

  const usersOptions = users
  .filter(user => user.role === "visiteur")
  .map((user) => ({
    value: user.id,
    label: `${user.prenom} ${user.nom}`,
  }));

  // Filtrer les projets pour exclure ceux avec l'état "visité"
  const filteredProjects = projects.filter(
    (project) => project.etat_projet !== "visité"
  );

  // Ajouter les options de projet filtrées au Select
  const projectOptions = filteredProjects.map((project) => ({
    value: project.id,
    label: project.nom_du_projet,
  }));

  const { selectedProjects } = useSelector((state: RootState) => state.projects);

  const onFinish = async (values: any) => {
    // Extract project IDs from selected projects
    const projectIds = selectedProjects.map(project => project.id);
    
    if (projectIds.length === 0) {
      toast.error("Veuillez sélectionner au moins un projet");
      return;
    }
    
    const payload = {
      fk_utilisateur: values.fk_utilisateur,
      fk_projets: projectIds
    };
    
    try {
      const response = await dispatch(affecterProject(payload)).unwrap();
      form.resetFields();
      // Clear selected projects after successful assignment
      dispatch(setSelectedProjects([]));
      setSelectedRowKeys([]);
      await dispatch(fetchUsersWithProjects());
    } catch (error) {
      console.error(error);
    }
  };

  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchProjects());
  }, []);

  return (
    <Form
      onFinish={onFinish}
      initialValues={initialeState}
      form={form}
      layout="vertical"
      style={{ marginBottom: "20px" }}
    >
      <Form.Item
        label="Nom visiteur"
        name="fk_utilisateur"
        rules={[{ required: true, message: "Veuillez choisir le visiteur" }]}
      >
        <Select
          showSearch
          placeholder="Selectionner un visiteur"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={usersOptions}
        />
      </Form.Item>

      {/* <Form.Item
        label="Projet"
        name="fk_projet"
        rules={[{ required: true, message: "Veuillez choisir un projet" }]}
      >
        <Select
          showSearch
          placeholder="Selectionner un projet"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={projectOptions}
        />
      </Form.Item> */}

      <Row style={{ width: "100%" }} justify={"end"}>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          Affecter
        </Button>
      </Row>
    </Form>
  );
};

export default Affectation_formulaire;
